import { Pagination } from "@mui/material";
import adminAPIs from "apis/AdminApis";
import { useEffect, useState } from "react";
const base_URL = process.env.REACT_APP_API_BASE_URL;

function GatePasses() {
    const [gatePasses, setGatePasses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const gatePassesPerPage = 10;

    useEffect(() => {
        fetchGatePasses();
    }, []);

    const fetchGatePasses = async () => {
        setLoading(true);

            const data = await adminAPIs.allGatePasses();
            setGatePasses(data?.data?.data?.passes || []);
            setTotalPages(Math.ceil(data?.data?.data?.total / gatePassesPerPage));

    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        fetchGatePasses(value);
    };

    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        setCurrentPage(1);
        fetchGatePasses(1, value);
    };
// //{
//     "id": 16,
//     "user_id": "cN89w9BvM0M5Xnug1gZdITKr7om1",
//     "visit_date": "2025-06-30T00:00:00.000Z",
//     "purpose": "meeting",
//     "tot_person": 1,
//     "arrival_time": "13:00:00",
//     "vehicle_num": "UK02GH11R11",
//     "valid_till": "2025-06-30T11:30:00.000Z",
//     "createdAt": "2025-06-08T05:08:00.128Z",
//     "updatedAt": "2025-06-08T05:08:00.128Z",
//     "user": {
//         "first_name": "Gaurav",
//         "last_name": "Gaurav",
//         "email": "geinicool009@gmail.com",
//         "school_num": "3068/N"
//     }
// },
  return (
    <div>
          <h1 className="text-2xl font-bold">Gate Passes</h1>
          <table className="w-full border-collapse border border-gray-300 ">
            <thead className="bg-gray-200">
              <tr className="border border-gray-300">
                <th className="border border-gray-300 text-center font-sm" width="10%">ID</th>
                <th className="border border-gray-300 text-center font-small">User</th>
                <th className="border border-gray-300 text-center font-small">Visit Date</th>
                <th className="border border-gray-300 text-center font-small">Purpose</th>
                <th className="border border-gray-300 text-center font-small">Total Person</th>
                <th className="border border-gray-300 text-center font-small">Vehicle Number</th>
                <th className="border border-gray-300 text-center font-small">Arrival Time</th>
                <th className="border border-gray-300 text-center font-small">Valid Till</th>

             </tr>
          </thead>
          <tbody className="border border-gray-300">
            {gatePasses.map((gatePass) => (
              <tr key={gatePass.id} className="border border-gray-300 hover:bg-gray-100 transition-colors text-center text-sm font-medium">
                <td>{gatePass.id}</td>
                    <td className="text-left py-4">{gatePass.user.first_name} {gatePass.user.last_name}
                        <br />
                        {gatePass.user.email}
                        <br />
                        {gatePass.user.school_num}
                        <br />
                        <span className="text-gray-500 text-sm font-medium">{new Date(gatePass.visit_date) < new Date()? <span class="text-red-500 bg-red-100 px-2 py-1 rounded-md">Expired</span>: <span class="text-green-500 bg-green-100 px-2 py-1 rounded-md">Valid</span>}</span>
                    </td>

                <td>{ new Date(gatePass.visit_date).toLocaleDateString()}</td>
                <td>{gatePass.purpose}</td>
                <td>{gatePass.tot_person}</td>
                <td>{gatePass.vehicle_num}</td>
                <td>{gatePass.arrival_time}</td>
                <td>{new Date(gatePass.valid_till).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination count={totalPages} page={currentPage} onChange={handlePageChange} color="primary" className="mt-4 justify-center"/>
    </div>
  );
}

export default GatePasses;